import React, { PropTypes } from 'react';
import Translate from 'react-translate-component';
import Utils from 'frilans-finans/utils/utils';

class LoyaltyPointsChart extends React.Component {

  static propTypes = {
    levels: PropTypes.array.isRequired,
    points: PropTypes.number.isRequired,
    currentLevelIndex: PropTypes.number
  };

  percentageCount () {
    const points = this.props.points;
    if (points <= 100000) {
      return this.getPercentage(0, 100000);
    } else if (points > 100000 && points < 250000) {
      return this.getPercentage(100000, 250000);
    } else if (points > 250000 && points < 500000) {
      return this.getPercentage(250000, 500000);
    } else if (points > 500000 && points < 1000000) {
      return this.getPercentage(500000, 1000000);
    } else if (points > 1000000 && points < 1500000) {
      return this.getPercentage(1000000, 1500000);
    } else if (points > 1500000) {
      return 100;
    }
  }

  getPercentage (min, max) {
    let decimals = (this.props.points - min) / (max - min);
    let procentage = decimals * 100;
    return procentage;
  }

  theLevel () {
    return this.props.levels[this.props.currentLevelIndex];
  }

  nextLevel () {
    return this.props.levels[this.props.currentLevelIndex+1];
  }

  nextlevelName () {
    const level = this.nextLevel();
    const transKey = level ? level.title : '';
    return <Translate content={transKey} />;
  }

  nextLevelPoints () {
    const level = this.theLevel();
    return level ? level.nextLevelPoints : '';
  }

  render () {
    return (
      <div className='loyalty-chart-wrapper'>
        <div className='loyalty-chart-title'>
          <Translate content='LOYALTY_CHART_TITLE'/>:
        </div>
        <div className='loyalty-chart-stats-info'>
          <div className='loyalty-chart-graph-container'>
            <div className='loyalty-chart-percent hide-mobile'>
              <svg
                viewBox="0 0 36 36"
                className='loyalty-chart-circular-chart'
              >
                <path
                  className='loyalty-chart-circle'
                  strokeDasharray="100, 100"
                  d="M18 2.0845
                  a 15.9155 15.9155 0 0 1 0 31.831
                  a 15.9155 15.9155 0 0 1 0 -31.831"
                />
                <path
                  className='loyalty-chart-circle'
                  strokeDasharray={this.percentageCount() + ', 100'}
                  d="M18 2.0845
                  a 15.9155 15.9155 0 0 1 0 31.831
                  a 15.9155 15.9155 0 0 1 0 -31.831"
                />
              </svg>
            </div>
            <div className='inside-chart-content'>
              <span className='conent-chart-points'>
                {Utils.numberWithSpaces(Utils.floor(this.props.points))}
              </span>
              <span className='conent-chart-points-of'>
                <Translate content='LOYALTY_CHART_POINTS_OF' />
                {' ' + Utils.numberWithSpaces(this.nextLevelPoints())}
              </span>
            </div>
          </div>
        </div>
        <div className='loyalty-chart-next-level'>
          <Translate content='LOYALTY_CHART_NEXT_LEVEL'/>&nbsp;
          {this.nextlevelName()} ({Utils.numberWithSpaces(this.nextLevelPoints())})
        </div>
      </div>
    );
  }
}
export default LoyaltyPointsChart;



/** WEBPACK FOOTER **
 ** ./src/views/loyalty-program/overview/chart.js
 **/